import { render } from "./CollapsibleTags.vue?vue&type=template&id=6582084c&scoped=true"
import script from "./CollapsibleTags.vue?vue&type=script&lang=js"
export * from "./CollapsibleTags.vue?vue&type=script&lang=js"

import "./CollapsibleTags.vue?vue&type=style&index=0&id=6582084c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6582084c"]])

export default __exports__